export default __webpack_public_path__ + "static/media/tier24.88fe02ca.png";